import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextHypmono = () => {

return(
<div>
    
<Typography variant="h6" >
<br />
Hypertension is a major risk factor for heart disease, stroke, kidney failure, and eye problems (Medline). 
Environmental factors also contribute to hypertension. In addition to race and age, activity level, alcohol consumption, and salt intake influence blood pressure. 
Other disorders, such as obesity, diabetes, and obstructive sleep apnea also increase the risk of developing hypertension. 
Hypertension or sustained high blood pressure (≥ 140/90 mmHg) is strongly associated with diabetic complications 
and known as a risk factor for atherosclerotic cardiovascular disease (ASCVD) and microvascular complications
<br /> <br /> 

Currently, the genetic architecture of hypertension encompasses approx. 30 monogenic rare variants which are tested here.

<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
 'CYP11B1', 'CYP11B2', 'CLCN2', 'KCNJ5', 'CACNA1H', 'CACNA1D', 'KCNJ5', 'SCNN1B', 'SCNN1G', 'CYP17A1', 'HSD11B2', 'NR3C2', 'WNK4', 'WNK1', 'KLHL3', 'CUL3', 'PDE3A', 'SDHA', 'SDHB', 
 'SDHC', 'SDHD', 'SDHAF2', 'MDH2', 'IDH3B', 'GOT2', 'DLST', 'SLC25A11', 'IDH1', 'IDH2', 'EGLN1', 'VHL', 'EPAS1', 'RET', 'MERTK', 'MET', 'TMEM127', 'FGFR1', 'NF1', 'HRAS', 
 'BRAF', 'MAX', 'CSDE1', 'UBTF', 'MAML3'  

<br /><br /> 
 
</Typography>

</div>
)
}